import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import API_BASE_URL from '../config/api';
import '../styles/Auth.css';

const SignUp = ({ onLogin }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    coupleCode: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [isNewCouple, setIsNewCouple] = useState(true);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const generateCoupleCode = () => {
    const code = Math.floor(1000 + Math.random() * 9000).toString();
    setFormData({ ...formData, coupleCode: code });
  };

  const validateForm = () => {
    if (!formData.name.trim()) {
      setError('Name is required');
      return false;
    }
    if (!formData.email.trim()) {
      setError('Email is required');
      return false;
    }
    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters');
      return false;
    }
    if (!formData.coupleCode.trim()) {
      setError('Couple code is required');
      return false;
    }
    if (formData.coupleCode.length !== 4) {
      setError('Couple code must be 4 digits');
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (!validateForm()) return;
    
    setLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/signup`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...formData,
          isNewCouple
        }),
      });

      const data = await response.json();

      if (response.ok) {
        onLogin(data.user, data.token);
        navigate('/dashboard');
      } else {
        setError(data.message || 'Sign up failed');
      }
    } catch (error) {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="heart-decoration">💕</div>
        <h2>Create Your Love Account</h2>
        <p>Start your journey together</p>

        {error && <div className="error-message">{error}</div>}

        <div className="couple-type-selector">
          <button
            type="button"
            className={`type-btn ${isNewCouple ? 'active' : ''}`}
            onClick={() => setIsNewCouple(true)}
          >
            💕 New Couple
          </button>
          <button
            type="button"
            className={`type-btn ${!isNewCouple ? 'active' : ''}`}
            onClick={() => setIsNewCouple(false)}
          >
            🔗 Join Partner
          </button>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <div className="input-icon">👤</div>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <div className="input-icon">📧</div>
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <div className="input-icon">🔒</div>
            <input
              type="password"
              name="password"
              placeholder="Create Password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group couple-code-group">
            <div className="input-icon">💕</div>
            <input
              type="text"
              name="coupleCode"
              placeholder={isNewCouple ? "Couple Code (will be generated)" : "Enter Partner's Couple Code"}
              value={formData.coupleCode}
              onChange={handleChange}
              required
              maxLength="4"
              readOnly={isNewCouple}
            />
            {isNewCouple && (
              <button
                type="button"
                className="generate-btn"
                onClick={generateCoupleCode}
              >
                Generate
              </button>
            )}
          </div>

          <div className="couple-info">
            {isNewCouple ? (
              <p>💡 Generate a couple code and share it with your partner</p>
            ) : (
              <p>💡 Enter the couple code your partner shared with you</p>
            )}
          </div>

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Creating Account...' : 'Create Account'}
          </button>
        </form>

        <p className="auth-link">
          Already have an account? <Link to="/signin">Sign In</Link>
        </p>
      </div>
    </div>
  );
};

export default SignUp;
